import{version as o}from"./version.js";const r=o=>o,e=o=>o,i=()=>`viem@${o}`;export{r as getContractAddress,e as getUrl,i as getVersion};
